// removed by extract-text-webpack-plugin
module.exports = {"NavButton":"_1wYzPoq8zwgsg08ZR9OwB3","BackNav":"_1s9f94xmsJm2BDaNLaxrFD","NavContainer":"_2mzubJtEolK601gMLgozQu","Icon":"xCpIjHXdX2byUO5Kv2qdd","NumberUnread":"_2dpn6xYnR6rLPJbZVUqiN5"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Feedback/style.css
// module id = 2045
// module chunks = 0